import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { watchForUpdates } from './lib/appUpdate';
import './index.css';

// Before render, so a deploy that lands while the console is open is noticed.
watchForUpdates();

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
